import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=1c244964&scoped=true&"
import script from "./navigator.vue?vue&type=script&lang=js&"
export * from "./navigator.vue?vue&type=script&lang=js&"
import style0 from "./navigator.vue?vue&type=style&index=0&id=1c244964&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c244964",
  null
  
)

export default component.exports